import { Component } from '@angular/core';

@Component({
    selector: 'app-awb-status',
    templateUrl: './awb-status.component.html',
    styleUrls: ['./awb-status.component.scss'],
    standalone: false,
})
export class AwbStatusComponent {}
